/**
 * Host-level (app shell) route-name constants.
 *
 * Phase 7 split the original `@/constants/routes` ROUTE_NAMES so this
 * file holds ONLY the names that survive after every feature has been
 * uninstalled: the Calendar landing surface and the catch-all 404. Every
 * domain surface — planner, officers, templates, onboarding, my-builds —
 * lives in its respective feature module
 * (`@/features/<feature>/constants/routes.ts`).
 *
 * The string VALUES stay byte-identical to Phase 6 (`'calendar'`,
 * `'not-found'`) so existing deep links still resolve.
 */
export const APP_ROUTE_NAMES = {
  Calendar: 'calendar',
  NotFound: 'not-found',
} as const

export type AppRouteName = (typeof APP_ROUTE_NAMES)[keyof typeof APP_ROUTE_NAMES]
